// frontend/src/components/EdaAnalysis/EdaDatasetStats.tsx

import React from 'react';

interface Props {
  analysis: any;
}

const renderValue = (value: any): React.ReactNode => {
  if (value === null || value === undefined) return '—';
  if (Array.isArray(value)) return value.join(', ');
  if (typeof value === 'object') return JSON.stringify(value);
  return String(value);
};

export const EdaDatasetStats: React.FC<Props> = ({ analysis }) => {
  return (
    <div style={{
      background: 'linear-gradient(135deg, #1a1a2e, #16213e)',
      borderRadius: '12px',
      padding: '20px',
      border: '1px solid #1a4a7a',
      marginBottom: '24px',
    }}>
      <h3 style={{ color: '#4fc3f7', margin: '0 0 16px 0' }}>📊 Visão Geral do Dataset</h3>

      {/* CAMADA 1: RESUMO DE NEGÓCIO */}
      <div style={{
        background: 'rgba(79, 195, 247, 0.08)',
        borderLeft: '3px solid #4fc3f7',
        borderRadius: '8px',
        padding: '16px',
        marginBottom: '20px',
        color: '#e0e0e0',
        fontSize: '14px',
        lineHeight: 1.6,
      }}>
        <p style={{ margin: '0 0 8px 0' }}>
          💡 <strong style={{ color: '#4fc3f7' }}>O que isso significa:</strong>
        </p>
        <p style={{ margin: 0 }}>
          O seu dataset possui <strong>{renderValue(analysis.rows_count)} registros</strong> (linhas) 
          e <strong>{renderValue(analysis.columns_count)} colunas</strong> (características). 
          O modelo vai aprender com esses dados para prever o target selecionado.
        </p>
      </div>

      {/* CAMADA 2: GRID TÉCNICO (O que já existia) */}
      <div style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))',
        gap: '16px',
      }}>
        <div className="stat-card" style={{ background: 'rgba(15, 42, 74, 0.4)', borderRadius: '8px', padding: '16px', border: '1px solid #1a4a7a' }}>
          <div style={{ fontSize: '24px', marginBottom: '8px' }}>📊</div>
          <div style={{ fontSize: '20px', fontWeight: 600, color: '#4fc3f7' }}>{renderValue(analysis.rows_count)}</div>
          <div style={{ fontSize: '13px', color: '#8899aa' }}>Registros</div>
        </div>
        <div className="stat-card" style={{ background: 'rgba(15, 42, 74, 0.4)', borderRadius: '8px', padding: '16px', border: '1px solid #1a4a7a' }}>
          <div style={{ fontSize: '24px', marginBottom: '8px' }}>📋</div>
          <div style={{ fontSize: '20px', fontWeight: 600, color: '#4fc3f7' }}>{renderValue(analysis.columns_count)}</div>
          <div style={{ fontSize: '13px', color: '#8899aa' }}>Colunas</div>
        </div>
        <div className="stat-card" style={{ background: 'rgba(15, 42, 74, 0.4)', borderRadius: '8px', padding: '16px', border: '1px solid #1a4a7a' }}>
          <div style={{ fontSize: '24px', marginBottom: '8px' }}>🎯</div>
          <div style={{ fontSize: '20px', fontWeight: 600, color: '#4fc3f7' }}>{renderValue(analysis.target_name)}</div>
          <div style={{ fontSize: '13px', color: '#8899aa' }}>Target</div>
        </div>
      </div>
    </div>
  );
};